import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-shape/src/order/reverse.js
// module id = ../../../../d3-shape/src/order/reverse.js
// module chunks = 3